// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__ib6B-","container":"Main_container__1V-h- container_container__PX4-e"};